// controls/layout3cols.js — bloc de mise en page 3 colonnes
import React from "react";
import CommonControls from "./inc/Common";

export function createLayout3colsField() {
  const id = "layout3cols_" + Date.now();

  return {
    type: "object",
    title: "Bloc 3 colonnes",
    "x-ui": "layout3cols",   // OBLIGATOIRE

    name: id,
    id: id,

    "x-columns": 3,
    "x-structure": [
      [],
      [],
      []
    ],

    properties: {}
  };
}


export function EditLayout3colsField({ field, onChange }) {
  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      <div className="alert alert-info small">
        Ce bloc contient 3 colonnes.
        Vous pouvez y glisser-déposer des champs dans l’éditeur.
      </div>
    </>
  );
}

export const RenderLayout3colsField = ({ field, renderChild }) => {
  const columns = field["x-structure"] || [[], [], []];

  return (
    <div className="row g-3 fb-layout-3cols">
      {columns.map((col, i) => (
        <div key={i} className="col-md-4">
          {col.map((childKey) =>
            renderChild(childKey)
          )}
        </div>
      ))}
    </div>
  );
};

export const editLayout3colsField = (props) => <EditLayout3colsField {...props} />;
